module.exports = "pegasus/assets/background-patterns/contemporary-china.png";